// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__akJ_R","col":"styles_col__2wT_A"};